import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonService } from 'src/app/services/common-services/common.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-industry-update-dialog',
  templateUrl: './industry-update-dialog.component.html',
  styleUrls: ['./industry-update-dialog.component.scss']
})
export class IndustryUpdateDialogComponent {
  
  baseUrl = environment.BASE_URL;
  industryData: any[] = [];
  // constructor(private service: CommonService, private dialogRef: MatDialogRef<IndustryDialogComponent>,private fb: FormBuilder){ 
  // }
  Others: string | null = '';

  interestsList: any[] = [];
  industryList: any[] = [];
  clickedIndustry: any = 0;

  constructor(private dialogRef: MatDialogRef<IndustryUpdateDialogComponent>, private service: CommonService, @Inject(MAT_DIALOG_DATA) public data: any) { }

  closeDialog(isTrue: Boolean) {
    this.dialogRef.close({ isTrue: isTrue, data: this.industryList });
  }
  ngOnInit() {
    if (this.data) {
      this.industryList = this.data.data;
      this.industryList.forEach((industry) => {
        if (industry.industryName === 'Others' && industry.others !== '') {
          this.Others = industry.others ? industry.others : null;
        }
      });
    }
  }

  getOthersValue(industry: any): string {
    if (industry.hasOwnProperty('others')) {
      return industry.others ? industry.others : this.Others;
    }
    return '';
  }

  toggleValueCheckIndustry(ev: any, sector: any) {
    sector.isChecked = ev.target.checked
  }
  clickIndustry(index: any) {
    this.clickedIndustry = index;
  }
  isIndustryChecked(index: any) {
    let isChecked = false;
    this.industryList[index].sectors.forEach((sector: any) => {
      if (sector.isChecked) {
        isChecked = true
      }
    });
    if (
      this.industryList[index].industryName === 'Others' && 
      this.Others !== null && 
      this.Others !== ''
    ) {
      isChecked = true;
      this.industryList[index].others = this.Others ? this.Others : null;
    }
    this.industryList[index]
    return isChecked;
  }

  // ngOnInit(){
  //  // this.getIndustry();
  // }



  // getIndustry() {
  //   this.service.getData(`${this.baseUrl}common-service/industry-management`).subscribe((res: any) => {
  //     this.industryData = res?.response;
  //   })
  // }

  // closeDialog(isTrue: Boolean) {
  //   this.dialogRef.close();
  // }
  // onSave(){
  //   // alert("hello");
  // }
}
